@if ($vm(); as vm) {
  @if (mode === 'compact') {
  <div class="yf-container gap-6 yf-oh oh--{{ vm.cls }}">
    <div class="yf-row centered gap-12">
      <div class="yf-container">
        <ion-icon [name]="vm.icon" style="font-size: 22px"></ion-icon>
      </div>
      <div class="grow">
        <ion-text class="fs-12 fw-600">{{ vm.line }}</ion-text>
      </div>
    </div>
  </div>
  } @else {
  <div class="yf-oh yf-oh--full">
    <button type="button" class="yf-oh__toggle oh--{{ vm.cls }}" (click)="toggle()" [attr.aria-expanded]="expanded">
      <ion-icon [name]="vm.icon" style="font-size: 20px"></ion-icon>
      <ion-text class="fs-13 fw-700 grow">{{ vm.line }}</ion-text>
      <ion-icon class="yf-oh__chev" [class.yf-oh__chev--open]="expanded" name="chevron-down-outline"></ion-icon>
    </button>

    @if (expanded) {
    <div class="yf-oh__body">
      @if (vm.hint) {
      <ion-text class="fs-12 yf-oh__hint">{{ vm.hint }}</ion-text>
      }

      @if (vm.twentyfourseven) {
      <ion-text class="fs-12 yf-oh__hint">{{ 'OPENING_HOURS.OPEN_24H' | translate }}</ion-text>
      } @else {
      <div class="yf-oh__week">
        @for (day of $week(); track day.weekday) {
        <div class="yf-oh__day" [class.yf-oh__day--today]="day.weekday === vm.todayWeekday">
          <ion-text class="fs-12 fw-600 yf-oh__dayname">{{ dayShort(day.weekday) }}</ion-text>
          <ion-text class="fs-12 yf-oh__hours">
            @if (day.periods.length) {{{ formatPeriods(day.periods) }}} @else {{{ 'OPENING_HOURS.CLOSED' | translate }}}
          </ion-text>
        </div>
        }
      </div>
      }
    </div>
    }
  </div>
}
}
